// userService.js
import apiClient from "./apiClient";

export const getUsers = () => apiClient.get("/users");
export const getUserById = (id) => apiClient.get(`/users/${id}`);
export const createUser = (data) => apiClient.post("/users", data);
export const updateUser = (id, data) => apiClient.put(`/users/${id}`, data);
export const deleteUser = (id) => apiClient.delete(`/users/${id}`);
export const assignUserToOffice = (userId, officeId) => apiClient.post(`/offices/${officeId}/users/${userId}`);
export const removeUserFromOffice = (userId, officeId) => apiClient.delete(`/offices/${officeId}/users/${userId}`);
export const getUserOffices = (id) => apiClient.get(`/users/${id}/roster`);
export const getMyOffices = (id) => apiClient.get(`/users/my/offices`);